import SOUNDS from 'sounds'

import requestAccountInfo from 'state/actions/account'

import { COMMAND_CENTER_TITLE, BUILDING_TITLES } from 'helpers/i18n.jsx'

export const CLAN_INDUSTRIAL_RESOURCE_REACTIVE_UPDATE = 'CLAN_INDUSTRIAL_RESOURCE_REACTIVE_UPDATE'
export const CLAN_TREASURY_REACTIVE_UPDATE = 'CLAN_TREASURY_REACTIVE_UPDATE'
export const CLAN_ATTRIBUTES_REACTIVE_UPDATE = 'CLAN_ATTRIBUTES_REACTIVE_UPDATE'

export const BUILDING_CONSTRUCT_REACTIVE = 'BUILDING_CONSTRUCT_REACTIVE'
export const BUILDING_UPGRADE_REACTIVE = 'BUILDING_UPGRADE_REACTIVE'
export const RESERVES_UPDATE_REACTIVE = 'RESERVES_UPDATE_REACTIVE'
export const STRONGHOLD_UPGRADE_REACTIVE = 'STRONGHOLD_UPGRADE_REACTIVE'
export const CLAN_ACTIVE_UNITS_UPDATE = 'CLAN_ACTIVE_UNITS_UPDATE'

export function clanIndustrialResourceUpdate({ industrial_resource }) {
    return {
        type: CLAN_INDUSTRIAL_RESOURCE_REACTIVE_UPDATE,
        payload: {
            industrial_resource,
        },
    }
}

export function clanTreasuryUpdate() {
    return (dispatch, getState) => {
        const { clan } = getState()
        const hasPermission = !!Object.keys(clan.treasury).length

        if (!hasPermission) return

        dispatch({
            type: CLAN_TREASURY_REACTIVE_UPDATE,
            payload: {},
        })

        dispatch(requestAccountInfo())
    }
}

export function buildingConstruct(payload) {
    return (dispatch, getState) => {
        const { account, locale, stronghold } = getState()
        // If action produced by current account - do nothing
        if (account.id === payload.account_id) return
        if (!stronghold.loaded) return

        const { building, slot_id: slotId } = payload
        const localizationId = BUILDING_TITLES[building.type].props.id
        const name = locale.messages[localizationId]

        dispatch({
            type: BUILDING_CONSTRUCT_REACTIVE,
            payload: {
                building: { ...building, name },
                slotId,
            },
            meta: {
                webToClient: {
                    handler: 'playSound',
                    params: { soundId: SOUNDS.BUILDING_CONSTRUCTION },
                },
            },
        })
    }
}

export function buildingUpgrade(payload) {
    return (dispatch, getState) => {
        const { account, locale, stronghold } = getState()
        // If action produced by current account - do nothing
        if (account.id === payload.account_id) return
        if (!stronghold.loaded) return

        const { building, slot_id: slotId } = payload
        const localizationId = BUILDING_TITLES[building.type].props.id
        const name = locale.messages[localizationId]
        dispatch({
            type: BUILDING_UPGRADE_REACTIVE,
            payload: {
                building: { ...building, name },
                slotId,
            },
            meta: {
                webToClient: {
                    handler: 'buildingUpgraded',
                    params: {
                        buildingName: name,
                        buildingLevel: building.level,
                    },
                },
            },
        })
    }
}

export function reserveUpdate(payload) {
    return (dispatch, getState) => {
        const { account } = getState()
        // If action produced by current account - do nothing
        if (account.id === payload.account_id) return

        const { type: reserveType, reserves } = payload
        dispatch({
            type: RESERVES_UPDATE_REACTIVE,
            payload: {
                reserves,
                reserveType,
            },
        })
    }
}

export function strongholdUpgrade(payload) {
    return (dispatch, getState) => {
        const { account, locale, stronghold } = getState()
        // If action produced by current account - do nothing
        if (account.id === payload.account_id) return
        if (!stronghold.loaded) return

        const localizationId = COMMAND_CENTER_TITLE.props.id
        const buildingName = locale.messages[localizationId]

        const { level, reserves } = payload
        dispatch({
            type: STRONGHOLD_UPGRADE_REACTIVE,
            payload: {
                reserves,
                level,
            },
            meta: {
                webToClient: {
                    handler: 'buildingUpgraded',
                    params: {
                        buildingName,
                        buildingLevel: level,
                    },
                },
            },
        })
    }
}

export function activeUnitsUpdate({ units_number }) {
    return {
        type: CLAN_ACTIVE_UNITS_UPDATE,
        payload: { units_number },
    }
}

export const actionCreators = {
    CLAN_INDUSTRIAL_RESOURCE_REACTIVE_UPDATE: clanIndustrialResourceUpdate,
    CLAN_TREASURY_REACTIVE_UPDATE: clanTreasuryUpdate,
    BUILDING_CONSTRUCT_REACTIVE: buildingConstruct,
    BUILDING_UPGRADE_REACTIVE: buildingUpgrade,
    RESERVES_UPDATE_REACTIVE: reserveUpdate,
    STRONGHOLD_UPGRADE_REACTIVE: strongholdUpgrade,
    CLAN_ACTIVE_UNITS_UPDATE: activeUnitsUpdate,
    CLAN_ATTRIBUTES_REACTIVE_UPDATE: requestAccountInfo,
}

export default function getActionCreator(type) {
    return actionCreators[type]
}



// WEBPACK FOOTER //
// ./channels/clan/actions.js